/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { NotificationRowFragmentDoc } from "./NotificationRow.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetNotificationsQueryVariables = Types.Exact<{
  first: Types.Scalars["Int"]["input"];
  after: Types.InputMaybe<Types.Scalars["Cursor"]["input"]>;
  statusFilter: Types.InputMaybe<Types.NotificationStatus>;
}>;

export type GetNotificationsQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly notifications: {
      readonly __typename: "UserNotificationsConnection";
      readonly pageInfo: {
        readonly __typename: "PageInfo";
        readonly hasNextPage: boolean;
        readonly endCursor: c.Cursor | null;
        readonly hasPreviousPage: boolean;
        readonly startCursor: c.Cursor | null;
      };
      readonly edges: ReadonlyArray<{
        readonly __typename: "UserNotificationsEdge";
        readonly node: {
          readonly __typename: "NotificationUserLink";
          readonly id: c.NotificationUserLinkId;
          readonly type: Types.InAppNotificationType;
          readonly contents: c.NotificationContents;
          readonly createdDate: c.DateTimeString;
          readonly status: Types.NotificationStatus;
          readonly fromUser: {
            readonly __typename: "User";
            readonly id: c.UserId;
            readonly name: string | null;
            readonly email: string;
            readonly imageUrl: string | null;
          } | null;
        } | null;
      }>;
    };
  } | null;
};

export type GetUnreadNotificationCountQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUnreadNotificationCountQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly unreadNotificationCount: number;
  } | null;
};

export type NewNotificationSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type NewNotificationSubscription = {
  readonly __typename: "Subscription";
  readonly newNotificationUserLink: {
    readonly __typename: "NotificationUserLink";
    readonly id: c.NotificationUserLinkId;
    readonly type: Types.InAppNotificationType;
    readonly contents: c.NotificationContents;
    readonly createdDate: c.DateTimeString;
    readonly status: Types.NotificationStatus;
    readonly fromUser: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly name: string | null;
      readonly email: string;
      readonly imageUrl: string | null;
    } | null;
  };
};

export type DeletedNotificationsSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type DeletedNotificationsSubscription = {
  readonly __typename: "Subscription";
  readonly deletedNotificationUserLinks: ReadonlyArray<c.NotificationUserLinkId>;
};

export type UnreadNotificationCountSubscriptionVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UnreadNotificationCountSubscription = {
  readonly __typename: "Subscription";
  readonly unreadNotificationCount: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly unreadNotificationCount: number;
  };
};

export type UpdateNotificationStatusMutationVariables = Types.Exact<{
  notificationUserLinkId: Types.Scalars["NotificationUserLinkId"]["input"];
  status: Types.NotificationStatus;
}>;

export type UpdateNotificationStatusMutation = {
  readonly __typename: "Mutation";
  readonly updateNotificationStatus: {
    readonly __typename: "NotificationUserLink";
    readonly id: c.NotificationUserLinkId;
    readonly status: Types.NotificationStatus;
    readonly recipient: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly unreadNotificationCount: number;
    };
  };
};

export type UpdateAllNotificationStatusesMutationVariables = Types.Exact<{
  status: Types.NotificationStatus;
}>;

export type UpdateAllNotificationStatusesMutation = {
  readonly __typename: "Mutation";
  readonly updateAllNotificationStatuses: ReadonlyArray<{
    readonly __typename: "NotificationUserLink";
    readonly id: c.NotificationUserLinkId;
    readonly status: Types.NotificationStatus;
    readonly recipient: {
      readonly __typename: "User";
      readonly id: c.UserId;
      readonly unreadNotificationCount: number;
    };
  }>;
};

export const GetNotificationsDocument = /*#__PURE__*/ gql`
  query GetNotifications(
    $first: Int!
    $after: Cursor
    $statusFilter: NotificationStatus
  ) {
    me {
      id
      notifications(first: $first, after: $after, statusFilter: $statusFilter) {
        pageInfo {
          hasNextPage
          endCursor
          hasPreviousPage
          startCursor
        }
        edges {
          node {
            id
            ...NotificationRowFragment
          }
        }
      }
    }
  }
  ${NotificationRowFragmentDoc}
`;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      statusFilter: // value for 'statusFilter'
 *   },
 * });
 */
export function useGetNotificationsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  > &
    (
      | { variables: GetNotificationsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(
    GetNotificationsDocument,
    options,
  );
}
export function useGetNotificationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, options);
}
export function useGetNotificationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetNotificationsQuery,
    GetNotificationsQueryVariables
  >(GetNotificationsDocument, options);
}
export type GetNotificationsQueryHookResult = ReturnType<
  typeof useGetNotificationsQuery
>;
export type GetNotificationsLazyQueryHookResult = ReturnType<
  typeof useGetNotificationsLazyQuery
>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<
  typeof useGetNotificationsSuspenseQuery
>;
export type GetNotificationsQueryResult = Apollo.QueryResult<
  GetNotificationsQuery,
  GetNotificationsQueryVariables
>;
export const GetUnreadNotificationCountDocument = /*#__PURE__*/ gql`
  query GetUnreadNotificationCount {
    me {
      id
      unreadNotificationCount
    }
  }
`;

/**
 * __useGetUnreadNotificationCountQuery__
 *
 * To run a query within a React component, call `useGetUnreadNotificationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnreadNotificationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnreadNotificationCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnreadNotificationCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >(GetUnreadNotificationCountDocument, options);
}
export function useGetUnreadNotificationCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >(GetUnreadNotificationCountDocument, options);
}
export function useGetUnreadNotificationCountSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUnreadNotificationCountQuery,
    GetUnreadNotificationCountQueryVariables
  >(GetUnreadNotificationCountDocument, options);
}
export type GetUnreadNotificationCountQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountQuery
>;
export type GetUnreadNotificationCountLazyQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountLazyQuery
>;
export type GetUnreadNotificationCountSuspenseQueryHookResult = ReturnType<
  typeof useGetUnreadNotificationCountSuspenseQuery
>;
export type GetUnreadNotificationCountQueryResult = Apollo.QueryResult<
  GetUnreadNotificationCountQuery,
  GetUnreadNotificationCountQueryVariables
>;
export const NewNotificationDocument = /*#__PURE__*/ gql`
  subscription NewNotification {
    newNotificationUserLink {
      id
      ...NotificationRowFragment
    }
  }
  ${NotificationRowFragmentDoc}
`;

/**
 * __useNewNotificationSubscription__
 *
 * To run a query within a React component, call `useNewNotificationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNewNotificationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewNotificationSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNewNotificationSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    NewNotificationSubscription,
    NewNotificationSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    NewNotificationSubscription,
    NewNotificationSubscriptionVariables
  >(NewNotificationDocument, options);
}
export type NewNotificationSubscriptionHookResult = ReturnType<
  typeof useNewNotificationSubscription
>;
export type NewNotificationSubscriptionResult =
  Apollo.SubscriptionResult<NewNotificationSubscription>;
export const DeletedNotificationsDocument = /*#__PURE__*/ gql`
  subscription DeletedNotifications {
    deletedNotificationUserLinks
  }
`;

/**
 * __useDeletedNotificationsSubscription__
 *
 * To run a query within a React component, call `useDeletedNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useDeletedNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeletedNotificationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useDeletedNotificationsSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    DeletedNotificationsSubscription,
    DeletedNotificationsSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    DeletedNotificationsSubscription,
    DeletedNotificationsSubscriptionVariables
  >(DeletedNotificationsDocument, options);
}
export type DeletedNotificationsSubscriptionHookResult = ReturnType<
  typeof useDeletedNotificationsSubscription
>;
export type DeletedNotificationsSubscriptionResult =
  Apollo.SubscriptionResult<DeletedNotificationsSubscription>;
export const UnreadNotificationCountDocument = /*#__PURE__*/ gql`
  subscription UnreadNotificationCount {
    unreadNotificationCount {
      id
      unreadNotificationCount
    }
  }
`;

/**
 * __useUnreadNotificationCountSubscription__
 *
 * To run a query within a React component, call `useUnreadNotificationCountSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationCountSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationCountSubscription({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationCountSubscription(
  baseOptions?: Apollo.SubscriptionHookOptions<
    UnreadNotificationCountSubscription,
    UnreadNotificationCountSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UnreadNotificationCountSubscription,
    UnreadNotificationCountSubscriptionVariables
  >(UnreadNotificationCountDocument, options);
}
export type UnreadNotificationCountSubscriptionHookResult = ReturnType<
  typeof useUnreadNotificationCountSubscription
>;
export type UnreadNotificationCountSubscriptionResult =
  Apollo.SubscriptionResult<UnreadNotificationCountSubscription>;
export const UpdateNotificationStatusDocument = /*#__PURE__*/ gql`
  mutation updateNotificationStatus(
    $notificationUserLinkId: NotificationUserLinkId!
    $status: NotificationStatus!
  ) {
    updateNotificationStatus(
      notificationUserLinkId: $notificationUserLinkId
      status: $status
    ) {
      id
      status
      recipient {
        id
        unreadNotificationCount
      }
    }
  }
`;
export type UpdateNotificationStatusMutationFn = Apollo.MutationFunction<
  UpdateNotificationStatusMutation,
  UpdateNotificationStatusMutationVariables
>;

/**
 * __useUpdateNotificationStatusMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationStatusMutation, { data, loading, error }] = useUpdateNotificationStatusMutation({
 *   variables: {
 *      notificationUserLinkId: // value for 'notificationUserLinkId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateNotificationStatusMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateNotificationStatusMutation,
    UpdateNotificationStatusMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateNotificationStatusMutation,
    UpdateNotificationStatusMutationVariables
  >(UpdateNotificationStatusDocument, options);
}
export type UpdateNotificationStatusMutationHookResult = ReturnType<
  typeof useUpdateNotificationStatusMutation
>;
export type UpdateNotificationStatusMutationResult =
  Apollo.MutationResult<UpdateNotificationStatusMutation>;
export type UpdateNotificationStatusMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateNotificationStatusMutation,
    UpdateNotificationStatusMutationVariables
  >;
export const UpdateAllNotificationStatusesDocument = /*#__PURE__*/ gql`
  mutation updateAllNotificationStatuses($status: NotificationStatus!) {
    updateAllNotificationStatuses(status: $status) {
      id
      status
      recipient {
        id
        unreadNotificationCount
      }
    }
  }
`;
export type UpdateAllNotificationStatusesMutationFn = Apollo.MutationFunction<
  UpdateAllNotificationStatusesMutation,
  UpdateAllNotificationStatusesMutationVariables
>;

/**
 * __useUpdateAllNotificationStatusesMutation__
 *
 * To run a mutation, you first call `useUpdateAllNotificationStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllNotificationStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllNotificationStatusesMutation, { data, loading, error }] = useUpdateAllNotificationStatusesMutation({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateAllNotificationStatusesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateAllNotificationStatusesMutation,
    UpdateAllNotificationStatusesMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateAllNotificationStatusesMutation,
    UpdateAllNotificationStatusesMutationVariables
  >(UpdateAllNotificationStatusesDocument, options);
}
export type UpdateAllNotificationStatusesMutationHookResult = ReturnType<
  typeof useUpdateAllNotificationStatusesMutation
>;
export type UpdateAllNotificationStatusesMutationResult =
  Apollo.MutationResult<UpdateAllNotificationStatusesMutation>;
export type UpdateAllNotificationStatusesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateAllNotificationStatusesMutation,
    UpdateAllNotificationStatusesMutationVariables
  >;
